import { connect } from 'react-redux';

import { CATEGORY_FILTER_OVERLAY_ID } from 'Component/CategoryFilterOverlay/CategoryFilterOverlay.config';
import { FILTER } from 'Component/Header/Header.config';
import {
    CategoryPageContainer as SourceCategoryPageContainer,
    mapDispatchToProps as sourceMapDispatchToProps,
    mapStateToProps as sourceMapStateToProps
} from 'SourceRoute/CategoryPage/CategoryPage.container';
import CategoryReducer from 'Store/Category/Category.reducer';
import { changeNavigationState, goToPreviousNavigationState } from 'Store/Navigation/Navigation.action';
import { TOP_NAVIGATION_TYPE } from 'Store/Navigation/Navigation.reducer';
import { hideActiveOverlay, toggleOverlayByKey } from 'Store/Overlay/Overlay.action';
import { withReducers } from 'Util/DynamicReducer';
import { getUrlMedia } from 'Util/Store';

export const ProductListDispatcher = import(
    /* webpackMode: "lazy", webpackChunkName: "dispatchers" */
    'Store/ProductListInfo/ProductListInfo.dispatcher'
);

/** @namespace Elganso/Route/CategoryPage/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    ...sourceMapStateToProps(state),
    topNavigationState: state.NavigationReducer[TOP_NAVIGATION_TYPE].navigationState
});

/** @namespace Elganso/Route/CategoryPage/Container/mapDispatchToProps */
export const mapDispatchToProps = (dispatch) => ({
    ...sourceMapDispatchToProps(dispatch),
    requestProductList: (options) => ProductListDispatcher.then(
        ({ default: dispatcher }) => dispatcher.handleData(dispatch, options)
    ),
    goToPreviousNavigationState: () => dispatch(goToPreviousNavigationState(TOP_NAVIGATION_TYPE)),
    showOverlay: (overlayKey) => dispatch(toggleOverlayByKey(overlayKey)),
    hideActiveOverlay: () => dispatch(hideActiveOverlay()),
    setNavigationState: (stateName) => dispatch(changeNavigationState(TOP_NAVIGATION_TYPE, stateName))
});

/** @namespace Elganso/Route/CategoryPage/Container */
export class CategoryPageContainer extends SourceCategoryPageContainer {
    containerFunctions = {
        ...this.containerFunctions,
        getRangoFilas: this.getRangoFilas.bind(this),
        getCurrentValue: this.getCurrentValue.bind(this),
        updateValue: this.updateValue.bind(this),
        getMedia: this.getMedia.bind(this),
        getMediaByID: this.getMediaByID.bind(this)
    };

    containerProps() {
        const {
            topNavigationState,
            goToPreviousNavigationState,
            location,
            history,
            changeNavigationState
        } = this.props;

        return {
            ...super.containerProps(),
            valueColumn: this.getCurrentValue(),
            topNavigationState,
            goToPreviousNavigationState,
            location,
            history,
            changeNavigationState
        };
    }

    getMedia() {
        const media = `${getUrlMedia()}perfumes/`;
        let storeCode = '';

        if (window.localStorage.config !== undefined) {
            const localStorageConfig = JSON.parse(window.localStorage.config);
            storeCode = localStorageConfig.data.storeConfig.code.toUpperCase();

            if (storeCode.indexOf('_') !== -1) {
                storeCode = storeCode.split('_')[1];
            }
        }

        const aviableCountryCode = ['CN', 'DE', 'EN', 'ES', 'FR', 'PT', 'UK'];
        if (!aviableCountryCode.find((country) => country === storeCode)) {
            storeCode = 'EN';
        }

        const countryCode = storeCode;

        const {
            isMobile
        } = this.props;

        let url_video_general_mujer = 'https://cdn.elganso.com/media/wysiwyg/Chic_PC.mp4';
        if (isMobile) {
            url_video_general_mujer = 'https://cdn.elganso.com/media/wysiwyg/Chic_movil.mp4';
        }

        const mediaArr = [
            {
                name: 'hombre',
                id: '1313',
                url_video: '',
                url_banner: `${ media }banners_categorias/Perfumes_Masc.jpg`,
                url_cover: `${ media }portadas/${ countryCode }/2000x2000-portadas-perfumes-hombre.jpg`
            },
            {
                name: 'mujer',
                id: '1314',
                url_video: url_video_general_mujer,
                url_banner: `${ media }banners_categorias/Perfumes_Fem.jpg`,
                url_cover: `${ media }portadas/${ countryCode }/2000x2000-portadas-perfumes-mujer.jpg`
            },
            {
                name: 'cofre',
                id: '1315',
                url_video: null,
                url_banner: `${ media }banners_categorias/banner-familiar-generico.jpg`,
                url_cover: `${ media }portadas/${ countryCode }/PortadaCatergoria_familia.jpg`
            },
            {
                name: 'tamanyo-viaje',
                id: '486',
                url_video: null,
                url_banner: `${ media }banners_categorias/Tamaño_Viaje.jpg`,
                url_cover: `${ media }portadas/${ countryCode }/2000x2000-portadas-tamanyo-viaje.jpg`
            }
        ];

        return mediaArr;
    }

    getMediaByID(childId) {
        const mediaArr = this.getMedia();
        return mediaArr.filter((cat) => parseInt(cat.id, 10) === childId);
    }

    getRangoFilas() {
        const { isMobile } = this.props;

        const min = 1;
        const max = isMobile ? 4 : 8;

        return { min, max };
    }

    getCurrentValue() {
        const { isMobile } = this.props;
        const cookies = window.sessionStorage.getItem('display_mode');
        if (cookies) {
            return cookies;
        }

        const currentValue = isMobile ? 2 : 4;

        return currentValue;
    }

    updateValue(e) {
        this.setState({ value: e.target.value });

        window.sessionStorage.setItem('display_mode', e.target.value);
    }

    getValueColumn() {
        const { value } = this.state;

        return value;
    }

    onFilterButtonClick() {
        const { goToPreviousNavigationState, toggleOverlayByKey, topNavigationState: { name } = {} } = this.props;

        toggleOverlayByKey(CATEGORY_FILTER_OVERLAY_ID);

        if (name === FILTER) {
            // Que se muestre correctamente el boton de los filtros o el icono de cerrar
            goToPreviousNavigationState();
        }
    }
}

export default withReducers({
    CategoryReducer
})(connect(mapStateToProps, mapDispatchToProps)(CategoryPageContainer));
